export const PixiToReactEventPropNames = Object.freeze({
    onclick: 'onClick',
    onglobalmousemove: 'onGlobalMouseMove',
    onglobalpointermove: 'onGlobalPointerMove',
    onglobaltouchmove: 'onGlobalTouchMove',
    onmousedown: 'onMouseDown',
    onmouseenter: 'onMouseEnter',
    onmouseleave: 'onMouseLeave',
    onmousemove: 'onMouseMove',
    onmouseout: 'onMouseOut',
    onmouseover: 'onMouseOver',
    onmouseup: 'onMouseUp',
    onmouseupoutside: 'onMouseUpOutside',
    onpointercancel: 'onPointerCancel',
    onpointerdown: 'onPointerDown',
    onpointerenter: 'onPointerEnter',
    onpointerleave: 'onPointerLeave',
    onpointermove: 'onPointerMove',
    onpointerout: 'onPointerOut',
    onpointerover: 'onPointerOver',
    onpointertap: 'onPointerTap',
    onpointerup: 'onPointerUp',
    onpointerupoutside: 'onPointerUpOutside',
    onrightclick: 'onRightClick',
    onrightdown: 'onRightDown',
    onrightup: 'onRightUp',
    onrightupoutside: 'onRightUpOutside',
    ontap: 'onTap',
    ontouchcancel: 'onTouchCancel',
    ontouchend: 'onTouchEnd',
    ontouchendoutside: 'onTouchEndOutside',
    ontouchmove: 'onTouchMove',
    ontouchstart: 'onTouchStart',
    onwheel: 'onWheel',
});
export const ReactToPixiEventPropNames = Object.freeze({
    onClick: 'onclick',
    onGlobalMouseMove: 'onglobalmousemove',
    onGlobalPointerMove: 'onglobalpointermove',
    onGlobalTouchMove: 'onglobaltouchmove',
    onMouseDown: 'onmousedown',
    onMouseEnter: 'onmouseenter',
    onMouseLeave: 'onmouseleave',
    onMouseMove: 'onmousemove',
    onMouseOut: 'onmouseout',
    onMouseOver: 'onmouseover',
    onMouseUp: 'onmouseup',
    onMouseUpOutside: 'onmouseupoutside',
    onPointerCancel: 'onpointercancel',
    onPointerDown: 'onpointerdown',
    onPointerEnter: 'onpointerenter',
    onPointerLeave: 'onpointerleave',
    onPointerMove: 'onpointermove',
    onPointerOut: 'onpointerout',
    onPointerOver: 'onpointerover',
    onPointerTap: 'onpointertap',
    onPointerUp: 'onpointerup',
    onPointerUpOutside: 'onpointerupoutside',
    onRightClick: 'onrightclick',
    onRightDown: 'onrightdown',
    onRightUp: 'onrightup',
    onRightUpOutside: 'onrightupoutside',
    onTap: 'ontap',
    onTouchCancel: 'ontouchcancel',
    onTouchEnd: 'ontouchend',
    onTouchEndOutside: 'ontouchendoutside',
    onTouchMove: 'ontouchmove',
    onTouchStart: 'ontouchstart',
    onWheel: 'onwheel',
});
